export const environment = {
  production: true,
  apiBase: 'https://api.tvshelper.com',
  canScrap: true
};
